<template>
  <div>
    <v-list flat>
      <v-list-item-group
        color="primary"
      >
        <v-list-item
          class="px-0 py-0"
          v-for="(guia, i) in guias"
          :key="i"
          :disabled="!disableAcoesGuias"
        >
          <v-list-item-content
            @click="() => handleGuiaClick(guia)"
          >
            <ItemGuia
              :disableAcoesGuias="disableAcoesGuias"
              :guia="guia"
              :selectedGuias="selectedGuias"
              :canDoActions="canDoActions"
              @checkboxClick="handleGuiaCheckboxClick"
            />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>
</template>

<script>
import ItemGuia from './ItemGuia.vue'

export default {
  components: {
    ItemGuia
  },
  props: {
    guias: Array,
    selectedGuias: Array,
    disableAcoesGuias: Boolean,
    canDoActions: Boolean
  },
  methods: {
    handleGuiaCheckboxClick (params) {
      this.$emit('guiaCheckboxClick', params)
    },
    handleGuiaClick (guia) {
      if (window?.getSelection()?.toString()) {
        return;
      } else if (this.disableAcoesGuias) {
        const params = {
          pagamentoId: this.$route.params.pagamentoId,
          pagamentoLoteId: this.$route.params.loteId
        }
        const query = {
          guia: guia.id
        }
        this.$router.push({ name: 'conciliacao', params, query })
      }
    }
  }
}
</script>

<style scoped>
.v-list-item__content{
  padding: 8px 0;
}
</style>
